import { gql } from '@apollo/client';

/**
 * #132 — завести или поменять цену курса по тарифу (upsert по
 * курс × тариф × валюта). Имя операции ≠ имя поля (`setCoursePlanPrice`).
 */
export const SaveCourseTariffPriceMutation = gql`
  mutation SaveCourseTariffPrice(
    $courseId: ID!
    $planId: ID!
    $currency: String!
    $amount: String!
  ) {
    setCoursePlanPrice(
      courseId: $courseId
      planId: $planId
      currency: $currency
      amount: $amount
    ) {
      success
      customErrors {
        field
        code
        message
      }
      price {
        id
        courseId
        planId
        planName
        planIsActive
        currency
        amount
      }
    }
  }
`;

/** #132 — убрать цену курса по тарифу (`deleteCoursePlanPrice`). */
export const RemoveCourseTariffPriceMutation = gql`
  mutation RemoveCourseTariffPrice($id: ID!) {
    deleteCoursePlanPrice(id: $id) {
      success
      customErrors {
        field
        code
        message
      }
    }
  }
`;
